import styled from 'styled-components'
import arrow from '../../atoms/DropDownArrow/dropDownArrow.png'

export const Card = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;

  width: 204px;
  height: 45px;
  background: white;
  padding: 0 1rem;
  border-radius: 20px;
  box-shadow: 4px 4px 18px -5px rgba(218, 221, 232, 0.8);
  margin: 0rem 1rem 1rem 0rem;
  @media (max-width: 768px) {
    display: grid;
    grid-template-columns: 20% 80%;
    width: 100%;
    margin-top: 0.7rem;
  }
`

export const Text = styled.p`
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 17px;
  letter-spacing: 0em;
  text-align: left;
`
export const DropDown = styled.select`
  display: block;
  font-size: 16px;
  font-family: sans-serif;
  font-weight: 700;
  color: #444;
  line-height: 1.3;
  padding: .6em 1.4em .5em .8em;
  width: 100%;
  max-width: 100%; 
  box-sizing: border-box;
  margin: 0;
  border:none;
  border-radius: .5em;
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
  background-color: transparent;
 
  linear-gradient(to bottom, #ffffff 0%,#e5e5e5 100%);
  background-repeat: no-repeat, repeat;
 
  background-position: right .7em top 50%, 0 0;
 
  background-size: 1em auto, 100%;
  appearance: none;
  background-image: url(${arrow});

`
